import axios from 'axios';
import { TRPMEvent } from 'components/main/rpm-event/rpm.types';
import { BILLING_API } from 'config';
import AuthService from 'services/auth-service';
import { installSessionInterceptor } from 'services/session';
import { RpmEventData } from './providerTimeTracker.types';

const contentType = 'application/json';

export enum RpmProviderEvent {
  ProviderViewMemberProfile = 'provider-view-member-profile',
  ProviderVisitMemberProfile = 'provider-visit-member-profile',
  ProviderSendPrivateMessageToMember = 'provider-send-private-message-to-member',
  ProviderSendPrivateMessageToProvider = 'provider-send-private-message-to-provider',
  ProviderReviewPicture = 'provider-review-picture',
  ProviderSendCard = 'provider-send-card',
  ProviderSendCardComment = 'provider-send-card-comment',
  ProviderSendFoodComment = 'provider-send-food-comment',

  // this event is created dynamically with the tab name from the variable GRAPH_TABS and could
  // be one of this weights, heart_rate, glucose, steps, blood_pressure, card, exercises, vitals, notes
  ProviderViewProfileChart = 'provider-view-profile-chart-',
  ProviderProfileAddWeight = 'provider-profile-add-weight',
}

export class ProviderTimeTrackerClient {
  customAxios = installSessionInterceptor(
    axios.create({
      baseURL: BILLING_API.url,
      headers: {
        Accept: `${contentType}`,
        'Content-Type': `${contentType}`,
      },
    })
  );

  constructor() {
    // Read per request: the client is created once, possibly before sign-in.
    this.customAxios.interceptors.request.use((config) => {
      const token = AuthService.getAuth()?.Authorization.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  track = async (data: RpmEventData) => {
    await this.customAxios.post<{ data: string }>(`/events`, data);
    return data;
  };

  list = async ({ patientUuid }: { patientUuid: string; limit?: number; offset?: number }) => {
    // TODO: send pagination elements when server is working correctly
    const url = `/events/${patientUuid}/patient`;
    const response = await this.customAxios.get<{
      events: {
        memberUuid: string;
        providerUuid: string;
        eventType: string;
        time: string;
      }[];
    }>(url);

    const dataReturn: TRPMEvent = {
      data: response.data.events,
      total: response.data.events.length,
    };

    return dataReturn;
  };
}
